function fillNodesWithData(selectors, value) {
	var nodes = document.querySelectorAll(selectors);

	for (var i = 0; i < nodes.length; i++) {
		if (nodes[i].tagName != 'INPUT') {
			nodes[i].innerHTML = value;
		} else {
			nodes[i].value = value;
		}
	}
}

window.addEventListener('message', function(event) {
	if (event.data.message === 'pickerResult') {
		DispensingPoints.select(event.data.point.id);

		$(dispensingPointsModal).modal("hide");
	}
	else if(event.data.point_id){ //DPD PL
		DispensingPoints.select(event.data.point_id);

		$(dispensingPointsModal).modal("hide");
	}

	if (event.origin == 'https://serv.meest.com') {
		let data = JSON.parse(event.data);
		DispensingPoints.select(data.id);

		$(dispensingPointsModal).modal("hide");
	}

	if(event.origin == 'https://widget.packeta.com') {
		let data = JSON.parse(event.data);
		if (data.packetaPoint !== null) {
			DispensingPoints.select(data.packetaPoint.id);
		}
	}

	if (event.data.message === 'skPostaPickerResult') {
		DispensingPoints.select(event.data.point.id);
	}

	const allowedOriginsInPost = [
		'https://sandbox-global-geowidget.easypack24.net',
		'https://geowidget-app.inpost.pl', //prod
		'https://global-geowidget.easypack24.net', // prod
	];
	if (allowedOriginsInPost.includes(event.origin)) {
		var point = event.data;
		if (point && point.name) {
			const externalId = point.name.replace(/^PL_/, '');

			DispensingPoints.select(externalId);
			$(dispensingPointsModal).modal("hide");
		}
	}

	if (event.data.message === 'skPostaPickerResult') {
		DispensingPoints.select(event.data.point.id);
	}

	if (event.data.hasOwnProperty("event_id") && event.data.event_id === "ps_data_handover") {
		let glsPoint = event.data.parcelshop.detail.pclshopid;

		DispensingPoints.select(glsPoint);

		$(dispensingPointsModal).modal("hide");
	}


	if (event.data.message === 'pickerResultMP') {
		DispensingPoints.select(event.data.point.id);

		$(dispensingPointsModal).modal("hide");
	}
});


var DispensingPoints = function () {
	var dispensingPointLink = ".s31-select-dispensing-point",
		$currentOpenAnchor,
		currentType;

	return {
		init: function () {
			$(dispensingPointLink).on("click", function (e) {
				$(this).parents(".s31-checkout-deliverypayment-item").find("input[type='radio']").click();

				var type = $(this).data("type");

				$currentOpenAnchor = $(this);
				currentType = type;

				if (type === "cpnapostu" || type === "cpbalikovna") {
					let typePost = "POST_OFFICE";
					if (type == "cpbalikovna") {
						typePost = "BALIKOVNY";
					}

					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html("" +
						'<iframe title="Výběr místa pro vyzvednutí zásilky"' +
						'src="https://b2c.cpost.cz/locations/?type=' + typePost + '" allow="geolocation" width="100%" height="100%" />'
					);
					$(dispensingPointsModal).modal("show");
				}
				else if (type === "dpdpl_pickup") {
					var code = $(this).data("code");

					var dpdUrl = "//pudofinder.dpd.com.pl/widget?key=e0cb5b1bf06c52202eaf12d81eeec7eb&query=PL&swip_box=1";
					if(code == "DPDPLPICK") {
						var dpdUrl = "//pudofinder.dpd.com.pl/widget?key=e0cb5b1bf06c52202eaf12d81eeec7eb&query=PL&points_with_services=1";
					}

					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html(
						'<iframe src="' + dpdUrl + '" allow="geolocation" width="100%" height="100%" />'
					);
					$(dispensingPointsModal).modal("show");
				} else if (type === "meest") {
					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html(
						'<iframe src="https://serv.meest.com/services/branches/?country=ua&org=36,38&partnerKey=PACKWAYMST" allow="geolocation" width="100%" height="100%" />'
					);
					$(dispensingPointsModal).modal("show");
				}
				else if (["zasilkovna", "zasilkovna_ext_hr", "zasilkovna_ext_si", "zasilkovna_ext_bg", "zasilkovna_ext_hu"].includes(type)) {
					var code = $(this).data("code");
					var vendor;

					// RO
					if (typeof localeCode !== 'undefined' && localeCode == 'ro_RO') {
						vendor = { country: "ro" };
						// BOX
						if (code == "CARBOX1") {
							vendor.group = "zbox";
						}

						packetaOptions = {
							country: "ro",
							language: "ro",
							vendors: [vendor]
						};
					}
					// HU
					else if (typeof localeCode !== 'undefined' && localeCode == 'hu_HU') {
						var vendors = [{ country: packetaCountry }];

						// BOX
						if (code == "HUBOX1") {
							vendors = [
								{ country: "hu", carrierId: "32970" } // FoxPost
							];
						}

						// PP
						packetaOptions = {
							country: packetaCountry,
							language: packetaCountry,
							vendors: vendors
						};
					}
					// HR, SI, BG
					else if (typeof localeCode !== 'undefined' && ['hr_HR', 'sl_SI', 'bg_BG'].includes(localeCode)) {
						var packetaCarriers = {
							hr_HR: { country: "hr", language: "hr", carrierId: "10619", boxCode: "HRBOX1", boxCarrierId: "35319" },
							sl_SI: { country: "si", language: "sl", carrierId: "25005", boxCode: "SIBOX1", boxCarrierId: "19517" },
							bg_BG: { country: "bg", language: "bg", carrierId: "19471", boxCode: "BGBOX1", boxCarrierId: "19470" }
						};
						var carrier = packetaCarriers[localeCode];

						packetaOptions = {
							country: carrier.country,
							language: carrier.language,
							vendors: [{
								country: carrier.country,
								carrierId: code == carrier.boxCode ? carrier.boxCarrierId : carrier.carrierId
							}]
						};
					}
					// Other
					else {
						vendor = { country: packetaCountry };
						// BOX
						if (code == "ZASBOX") {
							vendor.group = "zbox";
						}

						// PP
						packetaOptions = {
							country: packetaCountry,
							language: packetaCountry,
							vendors: [vendor]
						};
					}

					openPacketaWidget();
				}
				else if (type === "sk_pickup") {
					const config = {
						callback: function(pickupPoint) {
							if (pickupPoint) {
								window.postMessage({
									message: 'skPostaPickerResult',
									point: {
										id: pickupPoint.id,
										label: pickupPoint.label,
										kind: pickupPoint.kind,
										address: pickupPoint.deliveryAddress
									}
								}, window.location.origin);
							}
						},
					};

					slposta.PickupWidget.open(config);
				}
				else if (type === "inpost") {
					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html(
						'<inpost-geowidget id="inpost-widget" ' +
						'token="' + inpostToken + '" ' +
						'language="pl" ' +
						'country="PL" ' +
						'config="parcelCollect">' +
						'</inpost-geowidget>'
					);
					$(dispensingPointsModal).modal("show");
				}
				else if (type === "sk_pickup") {
					const config = {
						callback: function(pickupPoint) {
							if (pickupPoint) {
								window.postMessage({
									message: 'skPostaPickerResult',
									point: {
										id: pickupPoint.id,
										label: pickupPoint.label,
										kind: pickupPoint.kind,
										address: pickupPoint.deliveryAddress
									}
								}, window.location.origin);
							}
						},
					};

					slposta.PickupWidget.open(config);
				}
				else if (type === "glsparcelshop") {
					let ctrcode = "CZ";
					if (typeof localeCode !== 'undefined') {
						ctrcode = localeCode.split('_')[1];
					}

					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html("" +
						'<iframe title="Výběr místa pro vyzvednutí zásilky"' +
						'src="https://ps-maps.gls-czech.com/?ctrcode='+ctrcode+'&find=1" allow="geolocation" width="100%" height="100%" />'
					);
					$(dispensingPointsModal).modal("show");
				}
				else if (type === "magyarpostbox") {
					$(dispensingPointsModal).find(".s31-dispensingPoints-popupBodyCP").empty().html(
						'<iframe src="/magyar_posta/picker" allow="geolocation" width="100%" height="100%" />'
					);
					$(dispensingPointsModal).modal("show");
				}

			});
		},
		select: function (branchId) {
			$('body, html').animate({
				scrollTop: $(".s31-checkout-delivery").offset().top - 50
			}, 1);

			$.ajax({
				method: "PUT",
				cache: false,
				url: "/ajax/shipping/dispensing-point-ext/" + branchId + "/" + currentType,
				success: function (response) {
					var deliveryItem = $currentOpenAnchor.parent();
					if ($currentOpenAnchor.hasClass("s31-checkout-deliverypayment-item")) {
						deliveryItem = $currentOpenAnchor;
					}
					deliveryItem.find(".s31-dispensing-point-content").html(response);
					deliveryItem.find(".s31-select-dispensing-point").addClass("s31-button-back").removeClass("s31-button-submit");
					deliveryItem.find(".s31-checkout-delivery-method input")[0].dispatchEvent(new Event('change'));
				},
				error: function (jqXHR) {
					if (dispensingPointSetFailed != "") {
						var errorText = dispensingPointSetFailed;
					}
					else {
						var errorText = "Výdejní místo se nepodařilo nastavit. Zkuste to, prosím, později nebo vyberte jiné.";
					}

					$currentOpenAnchor.parent().find(".s31-dispensing-point-content").html(errorText);
				}
			});
		}
	};
}();

$(function () {
	DispensingPoints.init();
});

